import {lpp_types} from "./proto/compiled";

export abstract class LppTypes {
    static Color = (color: lpp_types.IColor) => `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a!/0xff})`;
}